import React from 'react';

export const TicketOpenTabsBar = ({
    tabs,
    onSelectTab,
    onCloseTab,
    isTabActive,
}) => {
    if (!Array.isArray(tabs) || tabs.length === 0) {
        return null;
    }

    return (
        <div className="ticket-open-tabs-wrap">
            <div className="ticket-open-tabs" role="tablist" aria-label="Tickets abiertos">
                {tabs.map((tab) => {
                    const isActive = isTabActive(tab.id);
                    const tabLabel = tab.code || `Ticket ${tab.id}`;

                    return (
                        <div key={`ticket-open-tab-${tab.id}`} className={`ticket-open-tabs__item ${isActive ? 'is-active' : ''}`}>
                            <button
                                type="button"
                                className="ticket-open-tabs__trigger"
                                onClick={() => onSelectTab(tab.id)}
                                aria-current={isActive ? 'page' : undefined}
                            >
                                <span className="ticket-open-tabs__code">{tabLabel}</span>
                                {tab.title && <span className="ticket-open-tabs__title">{tab.title}</span>}
                            </button>

                            <button
                                type="button"
                                className="ticket-open-tabs__close"
                                onClick={(event) => onCloseTab(event, tab.id)}
                                aria-label={`Cerrar pestaña ${tabLabel}`}
                            >
                                <i className="bi bi-x" />
                            </button>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};
